import { motion } from "framer-motion";
import MainLayout from "@/components/layout/MainLayout";
import YoungSchemasQuestionnaire from "@/components/personality/YoungSchemasQuestionnaire";
import PageSEO from "@/components/seo/PageSEO";

const YoungSchemasTest = () => {
  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://youcalm.org/app"
    },
    {
      position: 2,
      name: "Testes de Personalidade",
      item: "https://youcalm.org/testes-personalidade"
    },
    {
      position: 3,
      name: "Teste Esquemas de Young",
      item: "https://youcalm.org/teste-esquemas-young"
    }
  ];

  const structuredData = {
    "@type": "Course",
    "name": "Teste de Esquemas de Young",
    "description": "Avaliação psicológica baseada na Terapia do Esquema para identificar padrões emocionais e comportamentais profundos.",
    "provider": {
      "@type": "Organization",
      "name": "YouCalm"
    },
    "educationalLevel": "Intermediate",
    "timeRequired": "PT20M",
    "courseMode": "online"
  };

  return (
    <MainLayout>
      <PageSEO 
        title="Teste Esquemas de Young - YouCalm | Terapia do Esquema Online"
        description="Identifique seus esquemas emocionais profundos com o teste baseado na Terapia do Esquema de Jeffrey Young. Compreenda padrões que afetam seus relacionamentos."
        canonicalUrl="https://youcalm.org/teste-esquemas-young"
        keywords="esquemas young, terapia esquema, padrões emocionais, jeffrey young, teste psicológico"
        pageName="Teste Esquemas de Young"
        pageType="Course"
        structuredData={structuredData}
        breadcrumbs={breadcrumbs}
      />
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <YoungSchemasQuestionnaire />
      </motion.div>
    </MainLayout>
  );
};

export default YoungSchemasTest;
